import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { PatchCompanyDto } from '../../types/company.types';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useUpdate = () => {
  const { mutate: update, isPending } = useIdempotentAppMutation([QueryKey.PATCH_COMPANY], {
    mutationFn: (
      { companyId, data }: { companyId: string; data: PatchCompanyDto },
      { headers },
    ) => {
      return ApiService.patch(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId] },
        {
          body: { ...data, currencyCountryIso2Code: data.currencyCountryIso2Code || undefined },
          headers,
        },
      );
    },
  });
  return { patch: update, isPending };
};
